export const normalizeProductPrice = (price: number | null | undefined) =>
  (price ?? 0) / 100
